import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const API_URL = `${BASE_URL}/api/admin`;

const api = axios.create({
  baseURL: API_URL,
});

const getAuthConfig = (extra = {}) => {
  const token = localStorage.getItem('token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  return { headers: { ...headers, ...(extra.headers || {}) }, ...extra };
};

const methodAPI = {
    get: (endpoint, config = {}) => api.get(endpoint, getAuthConfig(config)).then(response => response.data),
    post: (endpoint, data, config = {}) => api.post(endpoint, data, getAuthConfig(config)).then(response => response.data),
    put: (endpoint, data, config = {}) => api.put(endpoint, data, getAuthConfig(config)).then(response => response.data),
    delete: (endpoint, config = {}) => api.delete(endpoint, getAuthConfig(config)).then(response => response.data)
};

export default methodAPI;